import React, { useEffect, useState } from "react";
import { ProductCategoryForHomePage as ProductCategoryForHomePage } from "src/components/api/register_product_category/registerProductCategory";
import { ToastError, ToastSuccess } from "src/components/uiElements/toast";
import { LOGOUT } from "src/components/helper/constants";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { SearchProduct as SEARCH_PRODUCT } from "src/components/api/search_product/searchProduct";
import { useNavigate } from "react-router-dom";

type RequestProps = {
    ProductCategoryMasterID: number;
    SearchText: string;
};

const UseProductSearchPanel = () => {
  const [selectCategoryList, setSelectCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const defaultValues = {
    ProductCategoryMasterID: 0,
    SearchText: "",
  };

  const validationSchema = Yup.object().shape({
    //SuperStarName: Yup.string().required("Super star name is required"),
  });

  const formContext = useForm<RequestProps>({
    defaultValues,
    resolver: yupResolver(validationSchema) as any,
  });
  const { reset, setValue } = formContext;

  const resetForm = () => {
    reset({
        ProductCategoryMasterID: 0,
        SearchText: "",
    });
  };

  useEffect(() => {
    ProductCategoryList();
  }, []);

  const ProductCategoryList = async () => {
    setSelectCategoryList([]);
    const response = await ProductCategoryForHomePage();
    console.log("response", response);
    if (!response?.isAuthorized) LOGOUT();
    if (!response?.status) {
      let failResult = JSON.parse(response?.data!);
      ToastError(failResult.Message);
      return;
    }
    var data = JSON.parse(response?.data!);
    setSelectCategoryList(data);
  };

  const SearchFilter: SubmitHandler<RequestProps> = async (values) => {
        let inputObj = {
            ProductCategoryMasterID : values.ProductCategoryMasterID,
            SearchText: values.SearchText,
        };
        let request = JSON.stringify(inputObj);
        setLoading(true);
        console.log("Product Search request", request);
        var response = await SEARCH_PRODUCT(request);
        console.log("Product Search response", response);
        setLoading(false);
        if (!response?.isAuthorized) LOGOUT();

        if (!response?.status) {
            let failResult = JSON.parse(response?.data!);
            ToastError(failResult.Message);
            return;
        }

        const result = JSON.parse(response?.data!);
        ToastSuccess(result.Message);
        navigate("/shop");
    };

  return {
    selectCategoryList,
    SearchFilter,
    formContext,
  };
};

export default UseProductSearchPanel;
